import React from 'react';
import { IconProps } from '../types';

export const User: React.FC<IconProps> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 20C20.4183 20 24 16.4183 24 12C24 7.58172 20.4183 4 16 4C11.5817 4 8 7.58172 8 12C8 16.4183 11.5817 20 16 20ZM16 20C13.5423 20 11.1278 20.6459 8.99944 21.8749C6.87104 23.1038 5.10367 24.8714 3.875 27M16 20C18.4577 20 20.8722 20.6459 23.0006 21.8749C25.129 23.1038 26.8963 24.8714 28.125 27"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
